import { useIntl } from 'react-intl';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Practitioner } from '@luminalearning/types';
import dayjs from 'dayjs';

type Props = {
    profile?: Practitioner | null,
    isLoading: Boolean,
};

const PremiumSubscriptionBody = (props: Props) => {
    const {
        profile,
        isLoading,
    } = props;

    const intl = useIntl();

    const [isPremium, setIsPremium] = useState(false);
    const [isMonths, setIsMonths] = useState<boolean>();
    const [expiry, setExpiry] = useState<number>();

    useEffect(() => {
        if (isLoading) return;
        if (!profile || !profile.subscriptionExpiryDate) return;
        const subscriptionExpiryDate = dayjs(profile.subscriptionExpiryDate.formatted);
        const expiresIn = Math.ceil(subscriptionExpiryDate.diff(dayjs(new Date()), 'months', true));

        setIsPremium(subscriptionExpiryDate.isAfter(dayjs()));

        if (expiresIn >= 12) {
            setIsMonths(false);
            setExpiry(Math.floor(expiresIn / 12));
        } else if (expiresIn < 12) {
            setIsMonths(true);
            setExpiry(expiresIn);
        }
    }, [profile, isLoading]);

    return (
        <div
            className={[
                // eslint-disable-next-line max-len
                'w-90 md:w-178 pt-0 h-auto mt-6 md:pt-4 md:mt-0 md:h-29 xl:w-auto pr-6 flex flex-col justify-center md:place-items-center',
                (isLoading ? 'animate-pulse' : ''),
            ].join(' ')}
        >
            {isPremium && !isLoading && profile && profile.practitionerSettings?.isShowSubscription
                && <div className=''>
                    <div className='mt-1 lg:ml-6 md:mt-4'>
                        <span className='font-bold mr-1'>
                            {
                                intl.formatMessage({
                                    id: 'LP_USER_SUBSCRIPTION',
                                    defaultMessage: 'Your Subscription:',
                                })
                            }
                        </span>

                        {
                            intl.formatMessage({
                                id: 'LP_LUMINA_PREMIUM',
                                defaultMessage: 'Lumina Premium',
                            })
                        }
                    </div>
                    <div className='flex flex-row md:ml-2 mt-2'>
                        <span>
                            <img src={'/img/lumina-learning_premium_gold-gradient.png'} className='h-100'
                                alt={intl.formatMessage({ id: 'LP_LUMINA_PREMIUM', defaultMessage: 'Lumina Premium' })} />
                        </span>
                        <div className='flex flex-col md:ml-1 mt-1'>
                            <span className='font-bold '>
                                {
                                    intl.formatMessage({
                                        id: 'LP_SUBSCRIPTION_EXPIRY',
                                        defaultMessage: 'Expires in',
                                    })
                                }
                            </span>
                            {isMonths
                                && <span className='font-bold flex flex-row text-accent'>
                                    <p className='mr-1'>
                                        { expiry }
                                    </p>
                                    {
                                        intl.formatMessage({
                                            id: 'LP_SUBSCRIPTION_MONTHS',
                                            defaultMessage: 'Months',
                                        })
                                    }
                                </span>
                            }
                            {!isMonths
                                && <span className='font-bold flex flex-row text-accent'>
                                    <p className='mr-1'>
                                        { expiry }
                                    </p>
                                    {
                                        intl.formatMessage({
                                            id: 'LP_SUBSCRIPTION_YEARS',
                                            defaultMessage: 'Years',
                                        })
                                    }
                                </span>
                            }
                        </div>
                        <div className='flex flex-col ml-4 md:ml-6 mt-1'>
                            <span className='font-bold'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_POINTS_BALANCE',
                                        defaultMessage: 'Points Balance',
                                    })
                                }
                            </span>
                            <span className='flex flex-row'>
                                <p className='font-bold text-accent mr-1'>
                                    <>
                                        { profile.remainingPoints }
                                    </>
                                </p>
                                {
                                    intl.formatMessage({
                                        id: 'LP_POINTS',
                                        defaultMessage: 'points',
                                    })
                                }
                            </span>
                        </div>
                    </div>
                </div>
            }
            {!isPremium && !isLoading && profile && profile.practitionerSettings?.isShowSubscription

                && <>
                    <div className='mt-1 md:ml-6 md:mt-4'>
                        <span className='font-bold mr-1'>
                            {
                                intl.formatMessage({
                                    id: 'LP_USER_SUBSCRIPTION',
                                    defaultMessage: 'Your Subscription:',
                                })
                            }
                        </span>
                        {
                            intl.formatMessage({
                                id: 'LP_LUMINA_ESSENTIAL',
                                defaultMessage: 'Lumina Essentials',
                            })
                        }
                    </div>
                    <div className='flex flex-row md:ml-2 mt-2'>
                        <span className=''>
                            <img src={'/img/luminaEssentials.png'} className='h-shortcut'
                                alt={intl.formatMessage({ id: 'LP_LUMINA_ESSENTIAL', defaultMessage: 'Lumina Essentials' })} />
                        </span>
                        <div className='flex flex-col ml-4 md:ml-6 mt-2'>
                            <span className='font-bold'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_POINTS_BALANCE',
                                        defaultMessage: 'Points Balance',
                                    })
                                }
                            </span>
                            <span className='flex flex-row'>
                                <p className='font-bold text-accent mr-1'>
                                    <>
                                        { profile.remainingPoints }
                                    </>
                                </p>
                                {
                                    intl.formatMessage({
                                        id: 'LP_POINTS',
                                        defaultMessage: 'points',
                                    })
                                }
                            </span>
                        </div>
                    </div>
                </>
            }
            {!isLoading && profile && !profile.practitionerSettings?.isShowSubscription
                && <>
                    <div className='flex flex-row md:ml-2 mt-2'>
                        <span className=''>
                            <img src={'/img/lumina-logo.png'} className='h-shortcut ml-4'
                                alt={intl.formatMessage({ id: 'LP_LUMINA_ESSENTIAL', defaultMessage: 'Lumina Essentials' })} />
                        </span>
                        <div className='flex flex-col ml-4 md:ml-6 mt-2'>
                            <span className='font-bold'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_POINTS_BALANCE',
                                        defaultMessage: 'Points Balance',
                                    })
                                }
                            </span>
                            <span className='flex flex-row'>
                                <p className='font-bold text-accent mr-1'>
                                    <>
                                        { profile.remainingPoints }
                                    </>
                                </p>
                                {
                                    intl.formatMessage({
                                        id: 'LP_POINTS',
                                        defaultMessage: 'points',
                                    })
                                }
                            </span>
                        </div>
                    </div>
                </>
            }
            {isLoading
                && <>
                    <div className=' md:ml-6 md:mt-4'>
                        <span className='font-bold mr-1'>
                            <Skeleton
                                baseColor='#d7d7d7'
                                highlightColor='#c8c8c8'
                                style={{ width: '300px', height: '15px' }}
                            />
                        </span>
                        <div className='flex flex-row'>
                            <Skeleton
                                baseColor='#d7d7d7'
                                highlightColor='#c8c8c8'
                                circle={false}
                                style={{ width: '100px', height: '60px' }}
                                className='items-start mr-5'
                            />
                            <div className='flex flex-col mt-2'>
                                <Skeleton
                                    baseColor='#d7d7d7'
                                    highlightColor='#c8c8c8'
                                    style={{ width: '90px', height: '15px' }}
                                />
                                <Skeleton
                                    baseColor='#d7d7d7'
                                    highlightColor='#c8c8c8'
                                    style={{ width: '90px', height: '15px' }}
                                />
                            </div>
                            <div className='flex flex-col mt-2 ml-8'>
                                <Skeleton
                                    baseColor='#d7d7d7'
                                    highlightColor='#c8c8c8'
                                    style={{ width: '90px', height: '15px' }}
                                />
                                <Skeleton
                                    baseColor='#d7d7d7'
                                    highlightColor='#c8c8c8'
                                    style={{ width: '90px', height: '15px' }}
                                />
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    );
};

export default PremiumSubscriptionBody;